import { Icon } from '@winnin/winnin_ui.components.icon'
import { Image } from '@winnin/winnin_ui.components.image'

import { ReactComponent as WinninLogo } from 'assets/images/svg/winnin-logo.svg'

import type { IDashboardBanner } from './dashboard-banner.types'
import './dashboard-banner.styles.scss'

export const DashboardBanner = ({ text, thumbnail, color, isMobile, subtitle }: IDashboardBanner) => {
  if (!text) return null
  if (isMobile) return <div className="DashboardBanner-mobile">{text}</div>
  return (
    <div className="DashboardBanner-wrapper" style={{ '--banner-color': color } as React.CSSProperties}>
      <div className="DashboardBanner-content-wrapper">
        <div className="DashboardBanner-content">
          {thumbnail ? (
            <Image src={thumbnail} alt="Thumbnail" height={56} width={56} />
          ) : (
            <div className="DashboardBanner-svgWrapper">
              <Icon icon="addTo" fill="white" height={56} width={56} />
            </div>
          )}
          <div className="DashboardBanner-textWrapper">
            {subtitle && <p className="DashboardBanner-subtitle">{subtitle}</p>}
            <p className="DashboardBanner-text">{text}</p>
          </div>
        </div>
        <div className="DashboardBanner-powered-by">
          <span>Powered by</span> <WinninLogo aria-label="Winnin logo" role="img" />
        </div>
      </div>
    </div>
  )
}
